<template>
	<div class="container-dba">
		<!-- 公共头部 -->
		<home-header></home-header>
		<!-- banner  -->
		<div class="banner-info"></div>
		<!-- 中间内容部分 -->
		<div class="edu-wrapper">
			<div class="meun">
				<div class="meun-right">
					<p class="right-title">项目简介</p>
					<div class="right-wapper">
						<div class="school-text"> 伴随经济高速发展，全球经济一体化将成为未来的发展趋势，人才供给也将呈现全球一体化格局，人才发展将成为经济发展的基石之一。</div>
						<div class="school-text"> 尤其是中国企业，身处国家新旧动能迭代期，密集型劳动逐步向思维型劳动转变，对企业家及企业高层管理者要求不断加强。</div>
						<div class="school-text">主动出击，主动提升知识储备是人才战略的第一步，更是关键一步。</div>
						<div class="school-text">本项目联合法国高等商学院——法国布雷斯特高等商学院，依靠法国高商优秀的精英教育系统，致力培养优秀的的商科界精英。</div>
						<div class="school-text">以培养学生的组织领导能力，加强实践经历，邀请具备全球500强企业工作经验、或拥有成功创业经历的教师授课，全方位培养学生的实践能力。</div>
						<!--<div class="image-wrapper"><img src="../assets/images/pic01.png"></div>-->
					</div>
					<p class="right-title">院校简介</p>
					<div class="right-wapper">
						<div class="image-wrapper"><img src="../assets/images/g1.jpg"></div>
						<div class="school-tip">布雷斯特高等商学院（Brest Business School，简称BBS），创办于1962年。学校共开设3校区，分别位于布雷斯特（Brest）、瓦纳（Vannes）和巴黎（Paris）。</div>
						<div class="image-wrapper"><img src="../assets/images/g2.jpg"></div>
						<div class="school-tip">布雷斯特高等商学院同时也是多个国际组织的成员：欧盟伊拉斯漠计划（Erasmus Scheme）、国际商学院促进协会（AACSB International）、欧洲国家教育协会（EAFIE）、欧洲管理发展基金会（EFMD）、拉丁美洲管理学院理事会（CLADEA）、国际大学创新联（IUIA）和国际互联网教育研究院（IERA）等。</div>
					</div>
					<p class="right-title">教学目标</p>
					<div class="right-wapper">
						<div class="school-tip">着重培养学生的组织领导能力，人际沟通与团队协作能力；</div>
						<div class="school-tip">培养具有坚实知识结构和实践能力的管理人才；</div>
						<div class="school-tip">培养具有创新思维、开放思维以及持续学习能力的商科界精英；</div>
						<div class="school-tip">培养具有国际视野、兼备竞争意识与团队精神的综合管理能力的未来领导者和企业家。</div>
					</div>
					<p class="right-title">教学理念</p>
					<div class="right-wapper">
						<div class="school-text">整合国内外高端教育资源，构建线上、线下结合、无围墙、无壁垒的开放式国际学历教育新模式。 </div>
						<div class="school-text">秉承“5Cs+L”的培养理念，即在教学过程、企业实践和论文撰写、答辩过程中始终贯穿培养学生的“竞争力（Competitiveness）、自信心(Confidence)、合作精神(Cooperativeness)、创造性 (Creativity)和诚信(Credibility)”，使之成为能够迎接全球化挑战、具有领导力（Leadership）的综合管理人才。</div>
					</div>
					<p class="right-title">教学方式</p>
					<div class="right-wapper">
						<div class="school-text">以课程学习、实践活动、课后自学、论文撰写为主，采取在职学习的方式完成课程学习。 </div>
						<div class="school-text">实行学分制。其中必修课每门4学分，选修课每门2学分；实践活动1次，2学分。最低学分要求48分。</div>
						<div class="school-text">在申请答辩之前须修满所要求的学分。根据在职研究生的特点，结合培养目标和选题意向，有针对性的开展多项社会实践活动，如企业参访，校际交流，社会公益活动，管理前沿讲座等。</div>
					</div>
					<p class="right-title">课程设置</p>
					<div class="right-wapper">
						<div class="apply">
							<ul>
								<li class="c2">01 营销管理 </li>
								<li class="c2">02 人力资源管理 </li>
								<li class="c2">03 企业管理原理与实务 </li>
								<li class="c2">04 顶层再造与运营管理 </li>
								<!--<li class="c2">05 人力资源管理</li>-->
								<!--<li class="c2">06 企业采购与供应链管理 </li>-->
								<li class="c2">05 项目管理</li>
								<li class="c2">06 企业财务 </li>
								<li class="c2">07 组织行为学 </li>
								<li class="c2">08 战略管理 </li>
								<li class="c2">09 领导力与变革管理 </li>
								<li class="c2">10 新商业赛道模式设计 </li>
								<li class="c2">11 定位与竞争 </li>
								<li class="c2">12 数字化零售新模式</li>
								<li class="c2">13 产品思维与产品创新 </li>
								<li class="c2">14 公司治理与股权</li>
								<li class="c2">15 商业计划书与路演 </li>
								<li class="c2">16 执行标准化建设与标杆管理</li>
								<li class="c2">17 问题分析与解决方法</li>
								<li class="c2">18 资产管理与传承</li>
								<li class="c2">19 供应链管理</li>
								<li class="c2">20 东西方哲学与经营</li>
								<div style="clear: both;"></div>
							</ul>
						</div>
					</div>
					<p class="right-title">实践活动</p>
					<div class="right-wapper">
						<div class="school-tip">实践活动结合企业或项目，选择与本专业学习有关的企业案例分析，企业诊断报告，及企业的创新创业实践等内容。</div>
					</div>
					<p class="right-title">毕业论文</p>
					<div class="right-wapper">
						<div class="school-tip">论文语言：中文，需翻译成英文提交BBS审核存档。</div>
						<div class="school-tip">答辩地点：中国。</div>
					</div>
					<p class="right-title">领衔导师</p>
					<div class="right-wapper">
						<div class="school-tip">何茂春： 国务院参事，BOSS商学院首席顾问，清华大学国际关系学系教授、博导。</div>
						<div class="school-tip">Luc PONTET： 布雷斯特高等商学院（Brest Business School）执行校长。</div>
						<div class="school-tip">Gaël TRIVIDIC： 布雷斯特高等商学院（Brest Business School）副教授，主讲战略管理。</div>
						<div class="school-tip">Gaëlle MOAL-ULVOAS： 布雷斯特高等商学院（Brest Business School）副教授，主讲国际商务与市场营销。</div>
						<div class="school-tip">胡 近： 上海交通大学党委副书记、教授、博导。</div>
						<div class="school-tip">姚淦铭： 江南大学文学院教授、博导。</div>
						<div class="school-tip">费一文： 上海交通大学安泰经济与管理学院副教授。</div>
						<div class="school-tip">张银杰： 上海财经大学教授、博士生导师。</div>
						<div class="school-tip">姜 伟： 青岛大学教授。</div>
						<div class="school-tip">徐 志： 南昌大学教授，中国市场学会理事，硕士生导师。</div>
						<div class="school-tip">尚 峰： 原华为大学项目负责人，实践并总结出大量管理经验及海内外标杆企业管理案例。</div>
						<div class="school-tip">喻 旭： 曾就职于易观国际，京东云首席顾问，在新零售和企业数字化转型领域颇有建树。</div>
						<div class="school-tip">王 雷： 曾任新浪网第一任产品总监，21世纪不动产集团（美国纽交所上市）副总裁，赶集网、百合网产品副总裁。</div>
						<div class="school-tip">张 斌： 曾任中华创业网CEO，曾任职于科特勒营销集团、摩托罗拉、飞利浦公司。</div>
					</div>
					<p class="right-title">申请材料</p>
					<div class="right-wapper">
						<div class="apply">
							<ul>
								<li>1、申请表(中英文各一份)手写签字 </li>
								<li>2、个人履历(中英文各一份)</li>
								<li>3、最高学历证书原件和复印件及英文翻译件</li>
								<li>4、身份证原件、复印件及英文翻译件</li>
								<!--<li>5、最高学历和学位证书复印件（学信网可查）*</li>-->
								<li>5、白底两寸照片4张和电子版，照片像素300以上</li>
								<li>6、名片4张</li>
								<li>7、推荐信1封（中文即可）需推荐人本人手写签名</li>
								<li>8、就职公司简介（中文即可）100字以上</li>
								<div style="clear: both;"></div>
							</ul>
						</div>
					</div>
					<p class="right-title">学分要求</p>
					<div class="right-wapper">
						<div class="school-tip">学制：标准学制2年。</div>
						<div class="school-tip">学位：对完成并符合培养方案主修要求的学生，授予管理学硕士学位。</div>
					</div>
					<div class="school-text" style="text-align: right;margin-top:0.5rem;">相关资料下载</div>
					<div class="school-text t2">
						<router-link to="pdfGlx">管理学</router-link>
					</div>
				</div>
			</div>
		</div>
		<home-footer></home-footer>
	</div>
</template>
<script>
	import HomeHeader from "@/components/homeHeader";
	import HomeFooter from "@/components/homeFooter";
	export default {
		name: "EduData",
		components: {
			HomeHeader,
			HomeFooter
		},
		data() {
			return {};
		},
		methods: {},
		mounted() {}
	};
</script>
<style scoped>
	/* .banner-info */
	
	.banner-info {
		width: 100%;
		height: 200px;
		background: url(../assets/images/banner002.png);
		background-size: 100% 100%;
	}
	
	.edu-wrapper {
		width: 95%;
		margin: 0 auto;
		margin-bottom: 50px;
	}
	
	.right-wapper {
		width: 100%;
	}
	
	.right-title {
		background: url(../assets/images/pic1.png) no-repeat;
		background-size: 100% 100%;
		width: 212px;
		height: 69px;
		text-align: center;
		line-height: 56px;
		font-size: 32px;
		padding-left: 40px;
		margin-top: 25px;
		margin-bottom: 17px;
	}
	/*文字样式*/
	
	.school-text {
		font-size: 29px;
		color: rgba(51, 51, 51, 1);
		line-height: 44px;
		text-indent: 50px;
		margin-top: 5px;
	}
	
	.school-tip {
		font-size: 29px;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 44px;
		margin-top: 5px;
	}
	
	.school-text a {
		color: #E58111;
	}
	
	.t2 {
		text-align: right;
		margin-top: 30px;
	}
	
	.teacher-title {
		font-size: 30px;
		color: #ED4014;
		margin-bottom: 10px;
	}
	
	.t5 {
		margin-top: 10px;
	}
	
	.t2 {
		text-align: right;
		margin-top: 30px;
	}
	
	.c4 {
		font-weight: bold;
	}
	/* 图片样式 */
	
	.image-wrapper {
		margin-top: 27px;
		margin-bottom: 25px;
		width: 100%;
	}
	
	.image-wrapper img {
		width: 100%;
		height: auto;
	}
	/* 课程样式 */
	
	.apply {
		width: 100%;
		min-height: 190px;
		background: #e58111;
		border-radius: 5px;
		overflow: hidden;
		zoom: 1;
	}
	
	.apply ul {
		margin: 22px 44px;
	}
	
	.apply li {
		font-size: 22px;
		color: #fff;
		width: 80%;
		float: left;
		line-height: 38px;
	}
	
	.c2 {
		width: 310px !important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/eduGlx.vue